export const setToken = (token: string) => {
  localStorage.setItem('klass_access_token', token);
};

export const deleteToken = () => {
  localStorage.removeItem('klass_access_token');
  window.location.pathname = '/login';
};

export const hasToken = () => !!localStorage.getItem('klass_access_token');
